exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".import-template-dialog[data-v-16ce388c] {\n  padding: 20px 30px 72px 30px;\n}\n.import-template-dialog .footer[data-v-16ce388c] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  text-align: right;\n  border-top: 1px solid var(--color3);\n  padding: 17px 20px;\n}\n.import-template-dialog .footer .dialog-buttons button[data-v-16ce388c] {\n  margin: 0px 10px;\n}\n", ""]);

// exports
